// this component was coded by wilfred reign for portfolio presentation
// website:  www.wilfredreign.netlify.app
// facebook: wilfred reign
// contact : +27 61 202 3165
// whatsapp: +27 61 202 3165

import React from "react";
import { Box } from "@mui/material";
import Gene20Box from "../../components/Gene20Box/Gene20Box";
import SwipeableTextMobileStepper from "../../components/gene20Carousel/carouselMUI";
import PresentationHeader from "../../components/PresentationComponents/header";

export default function PortfolioPresentation(props) {
  return (
    <Box sx={{ height: "100vh" }}>
      <Box
        sx={{
          backgroundImage: `linear-gradient(to bottom left ,#00330077 ,#005500e7 , #007700a7 , #000000)`,
          height: "100%",
          backdropFilter: "blur(1px)",
          display: "block",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Gene20Box
          sx={{
            zIndex: 0,
            height: "100%",
            width: "100%",
          }}
        >
          <SwipeableTextMobileStepper />
          <Gene20Box
            sx={{
              position: "absolute",
              display: "flex",
              width: "100%",
              height: "100%",
              bottom: "0",
            }}
          >
            <PresentationHeader />
          </Gene20Box>
        </Gene20Box>
      </Box>
    </Box>
  );
}
